module.exports = "<div class=\"page-furniture-detail furniture\">\r\n    <sku-info></sku-info>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./product-detail2024/page/furniture-page-content.html
// module id = 196
// module chunks = 0